
const FRENCH_PLATE = /^([A-Z]{2})[\s-]?(\d{3})[\s-]?([A-Z]{2})$/

export default {
  name: 'VehiclePlate',
  props: {
    plate: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
    },
  },
  computed: {
    normalized() {
      return this.plate.trim().toUpperCase()
    },
    french() {
      return FRENCH_PLATE.test(this.normalized)
    },
    formatted() {
      const match = this.normalized.match(FRENCH_PLATE)
      return match ? `${match[1]}-${match[2]}-${match[3]}` : this.normalized
    },
  },
}
